module.exports = __webpack_public_path__ + "img/40_38_073_940.aeb7e83c.jpg";